module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_vm._l((_vm.orderMaterialExpressList), function(orderMaterialExpress, index) {
    return _c('div', {
      attrs: {
        "id": index
      }
    }, [_c('div', {
      staticClass: "mod"
    }, [_c('div', {
      staticClass: "wrap1"
    }, [_c('div', {
      staticClass: "layer1"
    }, [(orderMaterialExpress.expressNo !== '') ? _c('span', {
      staticClass: "express-info"
    }, [_vm._v("快递单号：" + _vm._s(orderMaterialExpress.expressNo))]) : _c('span', {
      staticClass: "express-info"
    }, [_vm._v("快递单号：待填写")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "9px"
      }
    }, [_c('display-icon-and-status', {
      attrs: {
        "displayStatusName": orderMaterialExpress.displayStatusName,
        "displayType": _vm.emkt.SAMPLE_DISPLAY_TYPE.DISPLAY_NMAE
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "line"
    }), _vm._v(" "), _vm._l((orderMaterialExpress.expressMaterialDetailList), function(expressMaterialDetail, index) {
      return _c('div', {
        attrs: {
          "id": index
        }
      }, [_c('div', {
        staticClass: "layer3 flex-row"
      }, [_c('display-icon-and-status', {
        attrs: {
          "materialType": expressMaterialDetail.orderMaterialInfo.materialType,
          "displayType": _vm.emkt.SAMPLE_DISPLAY_TYPE.DISPLAY_ICON
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "txt3"
      }, [_vm._v(_vm._s(expressMaterialDetail.orderMaterialInfo.materialDesc))]), _vm._v(" "), _c('span', {
        staticClass: "status"
      }, [_vm._v(_vm._s(expressMaterialDetail.displayStatusName))])], 1)])
    }), _vm._v(" "), _c('div', {
      staticClass: "line"
    }), _vm._v(" "), _c('div', {
      staticClass: "layer5 flex-row"
    }, [_c('span', {
      staticClass: "info2"
    }, [_vm._v("创建时间：" + _vm._s(orderMaterialExpress.createDT))]), _vm._v(" "), _c('span', {
      staticClass: "txt4"
    }, [_vm._v("共" + _vm._s(orderMaterialExpress.expressMaterialDetailList.length) + "类物品")])]), _vm._v(" "), _c('div', {
      staticClass: "layer6 flex-col",
      on: {
        "click": function($event) {
          return _vm.modifyInfo(orderMaterialExpress)
        }
      }
    }, [_c('span', {
      staticClass: "info3"
    }, [_vm._v("修改信息")])])], 2)])])
  }), _vm._v(" "), _vm._m(0)], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "color": "#D2D2D6",
      "text-align": "center",
      "pointer-events": "none"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "12px",
      "margin-bottom": "50%"
    }
  }, [_vm._v("---我是有底线的---")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-afed295c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views_v_2.6/Material/MySampleDeliverySheet.vue
// module id = 1710
// module chunks = 8